import modal from '../../components/modal.vue'
import api from '../../api'
import maskedInput from '../../components/masked-input.vue'
import roles from '../../helpers/userRoles'

const roleNames = [
  { name: 'shared.after_printer', id: 'ROLE_AFTER_PRINTER' },
  { name: 'shared.printer', id: 'ROLE_PRINTER' },
  { name: 'shared.designer', id: 'ROLE_DESIGNER' },
  { name: 'shared.manager', id: 'ROLE_MANAGER' },
  { name: 'shared.director', id: 'ROLE_ADMIN' },
  { name: 'shared.master', id: 'ROLE_MASTER' },
  { name: 'shared.accountant', id: 'ROLE_ACCOUNTANT' }
]

function getUserList (users, self) {
  const result = []
  for (var user of users) {
    result.push({
      name: `${!user.firstname ? '' : user.firstname} ${
        !user.lastname ? '' : user.lastname
      }`,
      email: user.email,
      id: user.id,
      role: user.roles,
      roleName: self.$t(roleNames.find(x => x.id === user.roles).name),
      isInEdit: false,
      toogleEdit (val) {
        this.isInEdit = val
      }
    })
  }
  return result
}

export default {
  name: 'Staff',
  components: {
    modal,
    'masked-input': maskedInput
  },
  data: () => {
    return {
      users: [],
      newUser: {
        email: '',
        role: ''
      },
      roles: roleNames,
      addUserActive: false,
      showModalBeforeDelete: false
    }
  },
  methods: {
    showAddUser () {
      this.addUserActive = true
      this.newUser = {
        email: '',
        role: roleNames[0].id
      }
    },
    addUser (newUser) {
      newUser.email = newUser.email.trim()
      api.post.inviteUser(newUser).then(resp => {
        this.addUserActive = false
        if (resp.data.errors && resp.data.errors.length > 0) {
          this.$notify({
            message: this.$t('settings.can_not_add_user_with_email'),
            type: 'danger'
          })
        } else {
          this.loadUsers()
          this.$notify({
            message: this.$t('settings.user_were_added'),
            type: 'success'
          })
        }
      })
    },
    hideAddUser () {
      this.addUserActive = false
    },
    removeUser (userId) {
      this.showModalBeforeDelete = true
      this.onClickYesButton = () => {
        this.showModalBeforeDelete = false
        api.get.deleteUser(userId).then(() => {
          this.loadUsers()
          this.$notify({
            message: this.$t('settings.user_were_deleted'),
            type: 'danger'
          })
        })
      }
      this.onClickNoButton = () => {
        this.showModalBeforeDelete = false
      }
    },
    applyRole (userId, newRole) {
      const userInfo = {
        role: newRole
      }
      api.post.updateUser(userId, userInfo).then(() => {
        this.$notify({
          message: this.$t('settings.role_were_updated'),
          type: 'info'
        })
        this.loadUsers()
      })
    },
    loadUsers () {
      api.get
        .users()
        .then(response => {
          const users = response.data.data.users.filter(x => !x.deleted && x.roles !== roles.adAgent)
          this.users = getUserList(users, this)
        })
        .catch(() => this.$notify({
          message: 'Произошла ошибка',
          type: 'danger'
        }))
    },
    async changePlan (planId) {
      try {
        await api.post.updateCustomerInfo(this.$store.state.userInfo.customer.id, { billing_plan: planId })

        this.$notify({
          message: 'Заявка отправлена',
          type: 'success'
        })
      } catch {
        this.$notify({
          message: 'Произошла ошибка',
          type: 'danger'
        })
      }
    }
  },
  computed: {
    companyName: function () {
      return this.$store.state.userInfo.customer.name
    },
    plan () {
      return this.$store.state.userInfo.customer.billing_plan
    }
  },
  created () {
    this.loadUsers()
  },
  beforeRouteEnter (to, from, next) {
    next(vm => {
      vm.$eventBus.$emit('pageHeaderChange', 'Настройки')
    })
  }
}
